<template>
  <v-card flat>
    <v-card-title class="pa-0 ma-0">
      <v-checkbox
        v-model="value.opcao"
        color="secondary"
        :label="value.titulo"
      />
      <v-text-field
        v-if="value.opcao"
        v-model.trim="value.outros"
        label="Insira um termo"
        prepend-icon="search"
        class="ml-6 caption"
      />
      <slot name="children" />
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'FiltroExtra',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        titulo: '',
        opcao: false,
        outros: null,
      }),
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    disable(value) {
      if (value) {
        this.value.opcao = false;
      }
    },
    'value.opcao': function (value) {
      if (!value) {
        this.setDefault();
      }
    },
  },

  methods: {
    setDefault() {
      this.value.outros = null;
    },
  },
};
</script>
